import type { ChatMessage, ChatRoleService, LecturaUser } from '../core/types';

interface CreateStubChatRoleServiceOptions {
  getCurrentUser: () => LecturaUser | null;
}

export function createStubChatRoleService(opts: CreateStubChatRoleServiceOptions): ChatRoleService {
  return {
    canDeleteMessage(msg: ChatMessage): boolean {
      const user = opts.getCurrentUser();
      if (!user || !user.uid) return false;
      const ownerId = msg.userId || msg.uid;
      return !!ownerId && ownerId === user.uid;
    },
    getRole() {
      return 'viewer';
    },
    getAuthorRole(msg: ChatMessage) {
      if (msg.authorRole === 'admin' || msg.authorRole === 'presenter') return msg.authorRole;
      return null;
    },
    refresh(): Promise<void> {
      return Promise.resolve();
    }
  };
}
